import { fetchLabRemoteConfig } from 'actions/SystemActions'
import { OptimizelyFeatureFlags } from 'constants/optimizely'
import type { AppDispatch, AppStore } from 'src/client/store'

export default function initialiseLabRemoteConfig(
  store: AppStore,
  remoteConfigKeys: Array<string>,
): void {
  const state = store.getState()
  if (!state.system.features.flags[OptimizelyFeatureFlags.enableLabFeatureFlags]) return

  const dispatch = store.dispatch as AppDispatch
  dispatch(fetchLabRemoteConfig(remoteConfigKeys))
}
